window.addEventListener('DOMContentLoaded', () => {
    if ($('.experts').length) {
        var expertLink = document.querySelectorAll(".expertlink");
        var expertContent = document.querySelectorAll(".expertcontent");
    
    
        expertLink.forEach(function (el) {
          el.addEventListener("click", openExperts);
        });
        expertLink[0].click();
      }
    
      function openExperts(el) {
        var btnTarget = el.currentTarget;
        var section = btnTarget.dataset.section;
    
        expertContent.forEach(function (el) {
          el.classList.remove("active");
        });
    
        expertLink.forEach(function (el) {
          el.classList.remove("active");
        });
    
        document.querySelector("#" + section).classList.add("active");
    
        btnTarget.classList.add("active");
      }
          
});